// ** UI
import Box from '@mui/material/Box';

// ** Types
import type { SxProps, Theme } from '@mui/material/styles';

// ** Types
import type React from 'react';

export type ContentContainerProps = {
	children?: React.ReactNode;
	maxWidthPx?: number;
	disableGutters?: boolean;
	backgroundColor?: string;
	sx?: SxProps<Theme>;
	fullWidth?: boolean;
};

const ContentContainer = ({
	children,
	maxWidthPx = 1440,
	disableGutters,
	fullWidth = false,
	// backgroundColor,
	sx
}: ContentContainerProps) => {
	return (
		<Box
			sx={[
				{
					width: '100%',
					maxWidth: fullWidth ? '100%' : `${maxWidthPx}px`,
					mx: 'auto',
					...(disableGutters ? null : { px: { xs: 4, sm: 6, md: 8 } })
				},
				...(Array.isArray(sx) ? sx : sx ? [sx] : [])
			]}
		>
			{children}
		</Box>
	);
};

export default ContentContainer;
